import Clear from '@mui/icons-material/Clear';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    MenuItem,
    Tooltip,
    Typography
} from '@mui/material';
import IconeVotoRevogado from '@/components/IconeVotoRevogado';
import { action, computed, makeObservable, observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import IconesMagistradosProcesso from './IconesMagistradosProcesso';

class NotificacoesVotoAlterado extends ReactComponent {
    dialogOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            notificacoesAlertaVotoAlterado: computed,
            qtdVotosAlteradosRelator: computed,
            fecharModal: action,
            handleClickProcesso: action,
            handleClickNotificacoes: action,
            handleClickLimparNotificacoes: action,
            handleClickRemoverNotificacao: action,
            textoQtdMinutasAlteradas: computed
        });
    }

    get notificacoesAlertaVotoAlterado() {
        return this.sessaoStore.notificacoesAlertaVotoAlterado.filter(
            (registro) => registro.sessaoId === this.sessaoStore.idSessaoSelecionada
        );
    }

    get qtdVotosAlteradosRelator() {
        return this.notificacoesAlertaVotoAlterado.length;
    }

    fecharModal = () => {
        this.dialogOpen = false;
    };

    handleClickProcesso = (registro) => {
        this.salaSessaoStore.abrirProcesso(registro);
        this.fecharModal();
    };

    handleClickNotificacoes = () => {
        this.dialogOpen = true;
    };

    handleClickLimparNotificacoes = () => {
        this.sessaoStore.notificacoesAlertaVotoAlterado = this.sessaoStore.notificacoesAlertaVotoAlterado.filter(
            (registro) => registro.sessaoId !== this.sessaoStore.idSessaoSelecionada
        );
        this.fecharModal();
    };

    handleClickRemoverNotificacao = (registro) => {
        this.sessaoStore.notificacoesAlertaVotoAlterado = this.sessaoStore.notificacoesAlertaVotoAlterado.filter(
            (registroNotificacao) => registroNotificacao.numeroProcesso !== registro.numeroProcesso
        );

        if (this.notificacoesAlertaVotoAlterado.length === 0) {
            this.fecharModal();
        }
    };

    get textoQtdMinutasAlteradas() {
        return this.qtdVotosAlteradosRelator === 1
            ? '1 minuta de voto foi alterada pelo relator'
            : this.qtdVotosAlteradosRelator + ' minutas de votos foram alteradas pelos relatores';
    }

    render() {
        if (!this.qtdVotosAlteradosRelator) {
            return null;
        }

        return (
            <>
                <IconButton onClick={this.handleClickNotificacoes}>
                    <IconeVotoRevogado
                        title={this.textoQtdMinutasAlteradas}
                        removerEstiloPadrao
                        sx={{ margin: '0px 2px', cursor: 'pointer', backgroundColor: 'orange', fill: 'white' }}
                    />
                </IconButton>
                <Dialog
                    open={this.dialogOpen}
                    onClose={this.fecharModal}
                    maxWidth="md"
                >
                    <DialogTitle>As minutas de voto dos seguintes processos foram alteradas pelo Relator</DialogTitle>
                    <DialogContent>
                        {this.notificacoesAlertaVotoAlterado.map((registro) => (
                            <MenuItem
                                key={this.nextKey}
                                style={{ display: 'flex', justifyContent: 'space-between' }}
                            >
                                <Tooltip
                                    title={<Typography>Clique para abrir o processo</Typography>}
                                    placement="top"
                                >
                                    <Box
                                        style={{ margin: '10px 20px 10px 0px', minWidth: '280px', cursor: 'pointer' }}
                                        onClick={() => this.handleClickProcesso(registro)}
                                    >
                                        {registro.processo.numeroCompleto}
                                    </Box>
                                </Tooltip>
                                <IconesMagistradosProcesso registro={registro} />
                                <Tooltip
                                    title={<Typography>Remover notificação</Typography>}
                                    placement="top"
                                >
                                    <Clear onClick={() => this.handleClickRemoverNotificacao(registro)} />
                                </Tooltip>
                            </MenuItem>
                        ))}
                    </DialogContent>
                    <DialogActions>
                        <Tooltip title={<Typography>Remover todas as notificações da sessão</Typography>}>
                            <Button
                                onClick={this.handleClickLimparNotificacoes}
                                color="primary"
                            >
                                Limpar
                            </Button>
                        </Tooltip>
                        <Button
                            onClick={this.fecharModal}
                            color="secondary"
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default inject('stores')(observer(NotificacoesVotoAlterado));
